import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import Variation from '@cred/react-experiments/variation'

import { PERSONAL_INTERACTIVE_SAVINGS_CALCULATOR_EXPERIMENT_ID } from 'experiments/vtConfig'
import withExperimentProvider from 'components/hocs/withExperimentProvider'
import RichCta from 'components/rich-cta'
import PersonalLoanForm from 'components/form/personal'
import WidgetPage from 'components/hocs/widget-page'

import SavingsCalculatorCta from './savings-calculator'

const RichCtaApp = ({ utms, ...props }) => (
  <>
    <Variation experimentId={PERSONAL_INTERACTIVE_SAVINGS_CALCULATOR_EXPERIMENT_ID} id={0}>
      <RichCta
        url={`${config.credibleRoot}/personal-loan-prequalification`}
        formUrl={`${config.credibleRoot}/personal-loans/borrower`}
        title="Compare personal loan rates from top lenders"
        body="Loans for paying off credit cards, debt consolidation, home improvement and more."
        ctaText="Get Started"
        form={PersonalLoanForm}
        utms={utms}
        {...props}
      />
    </Variation>
    <Variation experimentId={PERSONAL_INTERACTIVE_SAVINGS_CALCULATOR_EXPERIMENT_ID} id={1}>
      <SavingsCalculatorCta utms={utms} {...props} />
    </Variation>
  </>
)

RichCtaApp.propTypes = {
  utms: PropTypes.object,
}

export default withExperimentProvider(WidgetPage(RichCtaApp))
